import type {CpcPaymentSuccessData} from './types';

import {dateToReadableDate} from '@date-picker';
import {Button, Divider} from '@ds/components';
import {PageLayout} from '@ds/layout';
import PinPaymentSuccessSvg from 'assets/images/pin-payment-success.svg';
import CpcInfoRow from 'modules/Cpc/components/common/CpcInfoRow/CpcInfoRow';
import {useLocation, useNavigate} from 'react-router-dom';

import {getCpcStateLabel} from '../utils';

const CpcPaymentSuccess: React.FC = () => {
  const {state} = useLocation();
  const navigate = useNavigate();
  const data = (state ?? {}) as CpcPaymentSuccessData;

  return (
    <PageLayout
      footer={
        <Button fullWidth onClick={() => navigate('/cpc/list')}>
          متوجه شدم
        </Button>
      }
    >
      <header className="flex min-h-87.5 flex-col items-center justify-center gap-2.5 p-2.5 text-center">
        <img src={PinPaymentSuccessSvg} alt="" aria-hidden />
        <h1 className="text-subtitle-lg text-neutral-fg">درخواست با موفقیت ثبت شد</h1>
        <p className="text-body-md text-gray-07">
          مبلغ قابل پرداخت در زمان تسویه در اولین موعد از فاکتور شما کسر می‌گردد.
        </p>
      </header>
      <Divider className="bg-gray-02" size={8} />
      <section className="px-2.5">
        <CpcInfoRow title="وضعیت" value={data.state ? getCpcStateLabel(data.state) : ''} />
        {data.start_date ? (
          <CpcInfoRow
            title="تاریخ"
            value={dateToReadableDate({date: data.start_date, month: true, day: true})}
          />
        ) : null}
        <CpcInfoRow
          title="نوع کمپین"
          value={data.renewal ? 'تکرار شونده' : 'عادی'}
          hasBorder={false}
        />
      </section>
    </PageLayout>
  );
};

export default CpcPaymentSuccess;
